import {PromotionDetailPage as PromotionDetailPageNewTheme} from '@/features/Promotions/PromotionDetailPage.jsx'
import {selectIsNewDesignCountry} from '@/store/slices/countryCodeSlice'
import {useSelector} from 'react-redux'
import PromotionDetail from './PromotionDetail'

/**
 * Select Promotion Type editor shell.
 * Selects legacy or new themed list by country.
 * @returns {JSX.Element}
 */
export const PromotionDetailEditor = () => {
  const isNewDesignCountry = useSelector(selectIsNewDesignCountry)

  return isNewDesignCountry ? <PromotionDetailPageNewTheme /> : <PromotionDetail />
}
